import { render, staticRenderFns } from "./RestrictionDetail.vue?vue&type=template&id=539b0534"
import script from "./RestrictionDetail.vue?vue&type=script&lang=ts"
export * from "./RestrictionDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports